import classNames from 'classnames'
import preval from "preval.macro"
import { FC } from 'react'
import { Col, Row } from 'reactstrap'
import { version as appVersion } from '../../../package.json'
import { WithTooltip } from './generic/WithTooltip'

const BUILD_DATE = preval`module.exports = Date.now();`

export const Footer: FC = () => {
    return (
        <div
            className={classNames(
                "d-flex p-2 px-3 justify-content-end",
                "border-top small",
                {'bg-danger text-white': process.env.NODE_ENV === 'development'},
                {'bg-light text-muted': process.env.NODE_ENV !== 'development'}
            )}
            style={{
                marginRight: "-15px",
                marginLeft: "-15px"
            }}
        >
            <Row>
                <Col className="cursor-default">
                    <WithTooltip place="top">
                        {ttId => {
                            return (
                                <div
                                    data-for={ttId}
                                    data-tip={"Build version and time"}
                                >
                                    {`RaidCDs v${appVersion}`}
                                    {" — "}
                                    {`${new Date(BUILD_DATE).toISOString()}`}
                                </div>
                            )
                        }}
                    </WithTooltip>
                </Col>
            </Row>
        </div>
    )
}
